import { apiGet } from 'APIPackage/MainModule/common/apiTools';
import { getServiceBaseURL } from 'APIPackage/MainModule/common/getServiceBaseURL';
import { APIServiceEnum } from 'APIPackage/MainModule/enums/APIServiceEnum';

import { IKnmNoticeType } from '../interfaces/IKnmNoticeType';

export async function fetchKnmNoticeMethods(): Promise<IKnmNoticeType[]> {
  return apiGet<IKnmNoticeType[]>(`${getServiceBaseURL(APIServiceEnum.BASE_SERVICE)}/catalogs/knm-notice-methods`);
}
